import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TotalUnreadMessageCountChipBadgeQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  channelMemberType: Types.ChannelMemberType;
}>;


export type TotalUnreadMessageCountChipBadgeQuery = { __typename?: 'Query', totalUnreadMessageCount: number };


export const TotalUnreadMessageCountChipBadgeDocument = gql`
    query TotalUnreadMessageCountChipBadge($userId: ID!, $channelMemberType: ChannelMemberType!) {
  totalUnreadMessageCount(userId: $userId, channelMemberType: $channelMemberType)
}
    `;

/**
 * __useTotalUnreadMessageCountChipBadgeQuery__
 *
 * To run a query within a React component, call `useTotalUnreadMessageCountChipBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalUnreadMessageCountChipBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalUnreadMessageCountChipBadgeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      channelMemberType: // value for 'channelMemberType'
 *   },
 * });
 */
export function useTotalUnreadMessageCountChipBadgeQuery(baseOptions: Apollo.QueryHookOptions<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables> & ({ variables: TotalUnreadMessageCountChipBadgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>(TotalUnreadMessageCountChipBadgeDocument, options);
      }
export function useTotalUnreadMessageCountChipBadgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>(TotalUnreadMessageCountChipBadgeDocument, options);
        }
export function useTotalUnreadMessageCountChipBadgeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>(TotalUnreadMessageCountChipBadgeDocument, options);
        }
export type TotalUnreadMessageCountChipBadgeQueryHookResult = ReturnType<typeof useTotalUnreadMessageCountChipBadgeQuery>;
export type TotalUnreadMessageCountChipBadgeLazyQueryHookResult = ReturnType<typeof useTotalUnreadMessageCountChipBadgeLazyQuery>;
export type TotalUnreadMessageCountChipBadgeSuspenseQueryHookResult = ReturnType<typeof useTotalUnreadMessageCountChipBadgeSuspenseQuery>;
export type TotalUnreadMessageCountChipBadgeQueryResult = Apollo.QueryResult<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>;
export const namedOperations = {
  Query: {
    TotalUnreadMessageCountChipBadge: 'TotalUnreadMessageCountChipBadge'
  }
}